import type {BasisState} from "../../..";
import {Action} from "../../../action/action";
import type DetailsState from "../detailsState";

export const SET_CUSTOMER_NAME = "SET_CUSTOMER_NAME";

export class SetCustomerName extends Action<typeof SET_CUSTOMER_NAME, string> {
  readonly type = SET_CUSTOMER_NAME;
  protected state: DetailsState;

  constructor(state: DetailsState, name?: string | undefined) {
    super(state, name);
    this.state = state;
  }
  /**
   * Business logic:
   * This action is only doable for Private Customers
   * @returns
   */
  public isDoable(): boolean {
    const customerType = this.state.customerType;
    const isPrivateCustomer = customerType === "Private";
    return isPrivateCustomer;
  }

  public isValid(): boolean {
    const {customerName} = this.state.bookingflowStateMachine.getData<DetailsState>();
    const isEmptyString = customerName === "";
    const isUndefined = customerName === undefined;
    return this.isDoable() && !isEmptyString && !isUndefined;
  }
}
